var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path)?_c('path',{style:({
    fill: 'url(#Gradient1)',
    fillOpacity: 0.5,
  }),attrs:{"d":_vm.path + "V " + (this.p.scaleY(this.p.minY)) + " H " + (this.p.scaleX(_vm.p.minX)) + " Z"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }